// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { enviroment } from "./enviromentType";

export const environment:enviroment = {
  production: false,
  API_URL: 'https://api-shellbox.itrock.com.ar/api',
  URL_MKTPLACE: 'https://marketshell-test.shellbox.ar/',
  COOKIE_DOMAIN: 'localhost',
  VERSION: '1.1',
  ASSET_URL: 'https://shellboxcontent.shell.com.ar/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
